// extracted by mini-css-extract-plugin
export default {"Current":"AnimateSelectionModal_Current__4RWw9"};